import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import Selectivity from 'selectivity/react';
import { Collapse } from 'react-bootstrap';

import { ADDRESS_TYPE } from 'stores/const';
import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';
import { isValidEmail, genGuid } from 'stores/utils';

import AddressBlock from 'components/AddressBlock';


//https://dev.to/alecgrey/controlled-forms-with-front-and-backend-validations-using-react-bootstrap-5a2
//https://codesandbox.io/s/l3pn7r2y8m?from-embed=&file=/src/index.js

const UserProfile = (props) => {
    const { isRegistration } = props;

    let history = useHistory();
    const auth = useAuth();
    const api = useApi();
    const { t } = useTranslation(['user-profile']);
    const [masterData] = useGlobal('masterData');
    const [modalProps, setModalProps] = useGlobal('modalProps');

    const [errors, setErrors] = useState({});
    const [isAgbChecked, setIsAgbChecked] = useState(false);
    const [regnSuccess, setRegnSuccess] = useState(false);
    const [showExternalId, setShowExternalId] = useState(false);
    const [isExternalIdMandatory, setIsExternalIdMandatory] = useState(false);

    const [personalData, setPersonalData] = useState(null);
    const [businessUnit, setBusinessUnit] = useState({
        refTimeZoneId: '8c8e81a2-328a-49b9-8746-fa87eb7dbff6'
    });
    const [authCobp, setAuthCobp] = useState(null);
    const [businessPartner, setBusinessPartner] = useState({
        refSalutationId: '',
        FirstName: '',
        Name: '',
        Email: '',
        Phone: '',
        Mobile: '',
        refLanguageId: '2d43bfd0-2d76-485e-b160-6a9a96148408',
        Username: '',
        Password: '',
        NewPassword: '',
        ConfirmPassword: '',
        ExternalId: ''
    });
    const [addressPost, setAddressPost] = useState({
        Street: '',
        AddressAddition: '',
        AddressName: '',
        City: '',
        PostalCode: '',
        refAddressTypeId: ADDRESS_TYPE.POSTAL,
        refCountryId: '',
    });
    const [addressBill, setAddressBill] = useState({
        Street: '',
        AddressAddition: '',
        AddressName: '',
        City: '',
        PostalCode: '',
        refAddressTypeId: ADDRESS_TYPE.BILLING,
        refCountryId: '',
    });
    const today = new Date();

    const refPwd = useRef(null);
    const refNewPwd = useRef(null);
    const refCnfPwd = useRef(null);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const toggleShowChangePassword = () => {
        setShowChangePassword(!showChangePassword);
    }

    const setField = (field, value) => {
        setBusinessPartner({
            ...businessPartner,
            [field]: value
        })
        // Check and see if errors exist, and remove them from the error object:
        if (!!errors[field]) setErrors({
            ...errors,
            [field]: null
        })
    }

    const savePassword = async (e) => {
        e.preventDefault();
        const newErrors = {};
        const { Password, NewPassword, ConfirmPassword } = businessPartner;
        if (!Password || Password === '') newErrors.Password = t("validation-password");
        if (!NewPassword || NewPassword === '') newErrors.NewPassword = t("validation-password1");
        if (!ConfirmPassword || ConfirmPassword === '') newErrors.ConfirmPassword = t("validation-password2");
        if (Object.keys(newErrors).length > 0) {
            // We got errors!
            setErrors(newErrors);
            return false;
        } else {
            try {
                let { Id, refUserBusinessPartnerId, Password, NewPassword, ConfirmPassword, Name, FirstName, Username, Email } = businessPartner;
                let userData = {
                    OrganizationBusinessPartner: [
                        { Id, refUserBusinessPartnerId, Password, NewPassword, ConfirmPassword, Name, FirstName, Username, Email }
                    ]
                }
                let result = await api.changePassword(userData);
                if (result) {
                    setModalProps({ ...modalProps, showModal: true, messages: [t("passwordChanged")] });
                    refPwd.current.value = '';
                    refNewPwd.current.value = '';
                    refCnfPwd.current.value = '';
                    setShowChangePassword(false);
                }
            }
            catch (error) {
                let message = error.response?.data?.Message;
                if (message) {
                    setModalProps({ ...modalProps, showModal: true, messages: message.split('\r\n') });
                }
            }
        }
    }

    const cleanAddress = (addressObj) => {
        let { Street, AddressAddition, AddressName, City, PostalCode, refAddressTypeId, refCountryId } = addressObj;
        return { Street, AddressAddition, AddressName, City, PostalCode, refAddressTypeId, refCountryId };
    }

    const resetIdsIfSame = (hbua, cobpa) => {
        let p1 = hbua.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
        let p2 = cobpa.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
        if (p1 && p2 && (p1.Id === p2.Id)) {
            p1.Id = genGuid();
        }

        let b1 = hbua.find(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
        let b2 = cobpa.find(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
        if (b1 && b2 && (b1.Id === b2.Id)) {
            b1.Id = genGuid();
        }
    }

    const updateProfile = async (e) => {
        e.preventDefault();
        const newErrors = findFormErrors();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        } else {
            let { refSalutationId, FirstName, Name, AddressName, Email, Phone, Mobile, refLanguageId, ExternalId } = businessPartner;
            const currentProfile = { ...personalData };
            currentProfile.OrganizationBusinessPartner[0] = {
                ...currentProfile.OrganizationBusinessPartner[0],
                refSalutationId, FirstName, Name, AddressName, Email, EmailConfirmed:true, Phone, Mobile, refLanguageId, ExternalId
            }
            let hbu = currentProfile.HomeBusinessUnit[0];
            const cleanAP = cleanAddress(addressPost);
            const cleanAB = cleanAddress(addressBill);
            let hbuAddressesNew = [];
            let cobpAddressesNew = [];
            let cobpaPostRefOrgId = null;
            let cobpaBillRefOrgId = null;
            if (currentProfile.CustomerOrganizationBusinessPartner && currentProfile.CustomerOrganizationBusinessPartner.length) {
                let cobp = currentProfile.CustomerOrganizationBusinessPartner[0];
                cobp.Email = Email;
                let cobpAddresses = currentProfile.CustomerOrganizationBusinessPartner[0].CustomerOrganizationBusinessPartnerAddress;
                if (cobpAddresses && cobpAddresses.length > 0) {
                    let paIndex = cobpAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
                    if (paIndex !== -1) {
                        let cobpPA = cobpAddresses[paIndex];
                        cobpaPostRefOrgId = cobpPA.refOrganizationId;
                        cobpAddressesNew.push({ ...cobpPA, ...cleanAP });
                    } else {
                        const cobpPAId = genGuid();
                        const cobpPostAddress = { ...cleanAP, Id: cobpPAId };
                        cobpAddressesNew.push(cobpPostAddress);
                    }
                    if (!isEmptyBA()) {
                        let baIndex = cobpAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
                        if (baIndex !== -1) {
                            let cobpBA = cobpAddresses[baIndex];
                            cobpaBillRefOrgId = cobpBA.refOrganizationId;
                            cobpAddressesNew.push({ ...cobpBA, ...cleanAB });
                        } else {
                            const cobpBAId = genGuid();
                            const cobpBillAddress = { ...cleanAB, Id: cobpBAId };
                            cobpAddressesNew.push(cobpBillAddress);
                        }
                    }
                }
            }
            if (hbu) {
                let hbuAddresses = hbu.BusinessUnitAddress;
                if (hbuAddresses && hbuAddresses.length > 0) {
                    let paIndex = hbuAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
                    if (paIndex !== -1) {
                        let hbuPA = hbuAddresses[paIndex];
                        if(hbuPA.refOrganizationId === cobpaPostRefOrgId) {
                            //don't update
                            console.log('will not update. keeping original PA.');
                            hbuAddressesNew.push({
                                ...hbuPA
                            });                               
                        } else {
                            console.log('will update PA.');
                            hbuAddressesNew.push({
                                ...hbuPA, ...cleanAP,
                                refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
                            });            
                        }
                    } else {
                        const hbuPAId = genGuid();
                        const hbuPostAddress = {
                            ...cleanAP, Id: hbuPAId,
                            refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
                        };
                        hbuAddressesNew.push(hbuPostAddress);
                    }
                    if (!isEmptyBA()) {
                        let baIndex = hbuAddresses.findIndex(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
                        if (baIndex !== -1) {
                            let hbuBA = hbuAddresses[baIndex];
                            if(hbuBA.refOrganizationId === cobpaBillRefOrgId) {
                                //don't update
                                console.log('will not update. keeping original BA.');     
                                hbuAddressesNew.push({
                                    ...hbuBA
                                });                                                             
                            } else {
                                console.log('will update BA.');
                                hbuAddressesNew.push({
                                    ...hbuBA, ...cleanAB,
                                    refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
                                });   
                            }                 
                        } else {
                            const hbuBAId = genGuid();
                            const hbuBillAddress = {
                                ...cleanAB, Id: hbuBAId,
                                refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
                            };
                            hbuAddressesNew.push(hbuBillAddress);
                        }
                    }
                } else {
                    const hbuPAId = genGuid();
                    const hbuPostAddress = {
                        ...cleanAP, Id: hbuPAId,
                        refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
                    };
                    hbuAddressesNew.push(hbuPostAddress);
                    if (!isEmptyBA()) {
                        const hbuBAId = genGuid();
                        const hbuBillAddress = {
                            ...cleanAB, Id: hbuBAId,
                            refBusinessUnitId: hbu.Id, refOrganizationId: hbu.refOrganizationId
                        };
                        hbuAddressesNew.push(hbuBillAddress);
                    }
                }
            }            
            resetIdsIfSame(hbuAddressesNew, cobpAddressesNew);
            currentProfile.HomeBusinessUnit[0].BusinessUnitAddress = hbuAddressesNew;
            currentProfile.CustomerOrganizationBusinessPartner[0].CustomerOrganizationBusinessPartnerAddress = cobpAddressesNew;
            try {
                let result = await api.updateProfile(currentProfile, auth.user.Id);
                if (result) {
                    setModalProps({ ...modalProps, showModal: true, messages: [t("profileSaved")] });
                }
            }
            catch (error) {
                let message = error.response?.data?.Message;
                if (message) {
                    setModalProps({ ...modalProps, showModal: true, messages: message.split('\r\n') });
                }
            }
        }
    }

    const createNewLessee = async (e) => {
        e.preventDefault()
        // get our new errors
        const newErrors = findFormErrors();
        // Conditional logic:
        if (Object.keys(newErrors).length > 0) {
            // We got errors!
            setErrors(newErrors);
            return false;
        } else {
            // No errors! Put any logic here for the form submission!
            try {
                var bpClone = { ...businessPartner };
                bpClone.Password = bpClone.NewPassword;
                delete bpClone.NewPassword;
                let result = await api.createProfile(businessUnit, bpClone, addressPost, (isEmptyBA() ? null : addressBill));
                if (result) {
                    //history.push('/registration/success');
                    setRegnSuccess(true);
                }
            }
            catch (error) {
                let message = error.response?.data?.Message;
                if (message) {
                    setModalProps({ ...modalProps, showModal: true, messages: message.split('\r\n') });
                }
            }
        }
    }

    const isEmptyBA = () => {
        return (!addressBill.Street && !addressBill.AddressAddition && !addressBill.PostalCode && !addressBill.City && !addressBill.refCountryId);
    }

    const findFormErrors = () => {
        const { refSalutationId, FirstName, Name, Email,
            Mobile, Username, NewPassword, ConfirmPassword, ExternalId } = businessPartner;
        const newErrors = {};
        // name errors
        if (!refSalutationId || refSalutationId === '') newErrors.refSalutationId = t("validation-salutation");;
        if (!FirstName || FirstName === '') newErrors.FirstName = t("validation-firstName");
        if (!Name || Name === '') newErrors.Name = t("validation-lastName");
        if (isExternalIdMandatory && (!ExternalId || ExternalId === '')) newErrors.ExternalId = t("validation-customerNumber");
        if (!isValidEmail(Email)) newErrors.Email = t("validation-email");
        if (!Mobile || Mobile === '') newErrors.Mobile = t("validation-mobile");

        if (isRegistration) {
            if (!Username || Username === '') newErrors.Username = t("validation-userName");
            if (!NewPassword || NewPassword === '') newErrors.NewPassword = t("validation-password1");
            if (!ConfirmPassword || ConfirmPassword === '') newErrors.ConfirmPassword = t("validation-password2");
        }

        if (!addressPost.Street) newErrors.Post_Street = t("validation-Street");
        if (!addressPost.PostalCode) newErrors.Post_PostalCode = t("validation-Code");
        if (!addressPost.City) newErrors.Post_City = t("validation-City");
        if (!addressPost.refCountryId) newErrors.Post_refCountryId = t("validation-Country");

        if (isEmptyBA()) {
            return newErrors;
        }
        if (!addressBill.Street) newErrors.Bill_Street = t("validation-Street");
        if (!addressBill.PostalCode) newErrors.Bill_PostalCode = t("validation-Code");
        if (!addressBill.City) newErrors.Bill_City = t("validation-City");
        if (!addressBill.refCountryId) newErrors.Bill_refCountryId = t("validation-Country");
        return newErrors;
    }

    const handleAGBClick = async () => { setIsAgbChecked(!isAgbChecked); }

    const getMaxBday = () => {
        let age18 = new Date();
        age18.setFullYear(age18.getFullYear() - 18);
        return age18;
    }

    const removeCredentials = async() => {
        let result = await api.removeCredentials(authCobp.Id);
        if(result) {
            await auth.login();
        }
    }

    const getProviderName = (code) => {
        var kv = {
            "ACC": "Availabill",
            "APL": "Apple Pay",
            "AMX": "American Express",
            "AZP": "Amazon Pay",
            "BON": "Boncard",
            "CFY": "Coinify",
            "CUP": "China Union Pay",
            "DEA": "iDEAL",
            "DIN": "Diners Club",
            "DIS": "Discover",
            "DNK": "Dankort",
            "DVI": "CRIF",
            "ECA": "MasterCard",
            "ELV": "SEPA",
            "EPS": "EPS",
            "ESY": "Swisscom Pay",
            "GPA": "Giropay",
            "INT": "Byjuno",
            "JCB": "JCB",
            "KLN": "Klarna",
            "MAU": "Maestro",
            "MDP": "Migros Bank",
            "MFA": "MF Group",
            "MFX": "MF Group",
            "MPX": "MF Group",
            "PAP": "PayPal",
            "PAY": "Google Pay",
            "PEF": "PostFinance",
            "PFC": "PostFinance",
            "PSC": "paysafecard",
            "REK": "Reka",
            "SAM": "Samsung Pay",
            "SWB": "Swissbilling",
            "SWP": "SwissPass",
            "TWI": "Twint",
            "UAP": "UATP",
            "VIS": "Visa",
            "SWH": "Swish",
        }
        return kv[code] || code;
    }

    const showRemoveCredentials = () => {
        setModalProps({
          ...modalProps,
          showModal: true,
          showCancel: true,
          okLabel: t("removeCredentialsOk"),
          cancelLabel: t("removeCredentialsCancel"),
          messages: [t("removeCredentialsQuestion")],
          isDeletion: true,
          onOk: removeCredentials,
        });
      }

    useEffect(() => {
        async function onInit() {
            let pData = await api.fetchPersonalData(auth.user.Id);
            if (pData) {
                setPersonalData(pData);
                setBusinessPartner(pData.OrganizationBusinessPartner[0]);
                let hbu = pData.HomeBusinessUnit[0];
                let bu = { ...hbu };
                delete bu.HomeBusinessUnit;
                setBusinessUnit(bu);
                let cobp = pData.CustomerOrganizationBusinessPartner[0];
                if (cobp) {
                    let address1 = cobp.CustomerOrganizationBusinessPartnerAddress?.find(item => item.refAddressTypeId === ADDRESS_TYPE.POSTAL);
                    if (address1) {
                        address1.refOrganizationId = cobp.refOrganizationId;
                        setAddressPost({ ...address1 });
                    }
                    let address2 = cobp.CustomerOrganizationBusinessPartnerAddress?.find(item => item.refAddressTypeId === ADDRESS_TYPE.BILLING);
                    if (address2) {
                        address2.refOrganizationId = cobp.refOrganizationId;
                        setAddressBill({ ...address2 });
                    }
                }
            }
            var auCobp = auth.user.CustomerOrganizationBusinessPartner[0];
            if(auCobp) {
                setAuthCobp(auCobp);
            }
        }

        if (!isRegistration && auth.user) {
            onInit();
        }
    }, [auth.user]);

    useEffect(() => {
        const onInit = () => {
            setShowExternalId(masterData.organization.IsExternalIdEditableByLessee);
            setIsExternalIdMandatory(masterData.organization.IsExternalIdMandatory);
        }
        onInit();
    }, [])

    return (
        <>
            {(!isRegistration || (isRegistration && !regnSuccess)) && <section className="profile-container">
                <div className="wrapper">

                    <div className="row profile-content">
                        <div className="column-12">
                            <h3 className="mali-blue">
                                {isRegistration ? t("registrationTitle") : t("profileTitle", { firstName: businessPartner.FirstName })}
                            </h3>
                            {isRegistration ?
                                <h4 className="mali-blue">{t("registrationSubtitle")}</h4>
                                :
                                <h4 className="mali-blue">{t("profileSubtitle")}</h4>
                            }
                        </div>
                    </div>

                    <div className={`${isRegistration ? "profileInfo-container regn" : "profileInfo-container profile"}`}>
                        <div className="row customer-info-container">
                            <div className="column-8 offset-2">
                                <h4>{t("customerInformation")}</h4>
                            </div>
                            <div className="column-8 offset-2">
                                <Form.Group>
                                    <Form.Label>{t("salutation")}</Form.Label>
                                    <div className="form-control form-select">
                                        <Selectivity.React
                                            multiple={false}
                                            items={masterData.salutations}
                                            placeholder={t("salutation")}
                                            className="sr-wrapper"
                                            value={businessPartner.refSalutationId}
                                            onChange={e => setField('refSalutationId', e.value)}
                                        />
                                    </div>
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.refSalutationId}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("firstName")}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={businessPartner.FirstName}
                                        onChange={e => setField('FirstName', e.target.value)}
                                    />
                                    {/* <div className={`feedback ${errors.firstName ? 'invalid' : 'hidden'}`}>
                                        {errors.firstName}
                                    </div> */}
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.FirstName}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("lastName")}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={businessPartner.Name}
                                        onChange={e => setField('Name', e.target.value)}
                                    />
                                    {/* <div className={`feedback ${errors.lastName ? 'invalid' : 'hidden'}`}>
                                        {errors.lastName}
                                    </div> */}
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.Name}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {showExternalId && <Form.Group>
                                    <Form.Label>{t("customerNumber")}{isExternalIdMandatory && " *"}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={businessPartner.ExternalId}
                                        onChange={e => setField('ExternalId', e.target.value)}
                                    />
                                    {isExternalIdMandatory && <Form.Control.Feedback type='invalid'>
                                        {errors.ExternalId}
                                    </Form.Control.Feedback>}
                                </Form.Group>}

                                <Form.Group>
                                    <Form.Label>{t("organization")}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={addressPost.AddressName}
                                        onChange={e => setAddressPost({ ...addressPost, AddressName: e.target.value })}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("email")}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={businessPartner.Email}
                                        onChange={e => setField('Email', e.target.value)}
                                        isInvalid={!!errors.Email}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.Email}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("phone")}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={businessPartner.Phone}
                                        onChange={e => setField('Phone', e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("mobilePhone")}</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={businessPartner.Mobile}
                                        onChange={e => setField('Mobile', e.target.value)}
                                        isInvalid={!!errors.Mobile}
                                    />
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.Mobile}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("timezone")}</Form.Label>
                                    <div className="form-control form-select">
                                        <Selectivity.React
                                            multiple={false}
                                            items={masterData.timezones}
                                            placeholder={t("timezone")}
                                            className="sr-wrapper"
                                            value={businessUnit.refTimeZoneId}
                                            onChange={e => setField('refTimeZoneId', e.value)}
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>{t("language")}</Form.Label>
                                    <div className="form-control form-select">
                                        <Selectivity.React
                                            multiple={false}
                                            items={masterData.languages}
                                            placeholder={t("language")}
                                            className="sr-wrapper"
                                            value={businessPartner.refLanguageId}
                                            onChange={e => setField('refLanguageId', e.value)}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {authCobp && authCobp.AliasCC && <div className="row payment-credentials-container">
                            <div className="column-8 offset-2">
                                <h4>{t("cc_saved_credentials")}</h4>
                            </div>
                            <div className="column-8 offset-2">
                                <div className="actions-paymentinfo">
                                    <span className="cc-provider">{getProviderName(authCobp.PaymentMethodCC)}</span>
                                    <span className="cc-expiry">{authCobp.ExpmCC}/{authCobp.ExpyCC}</span>
                                </div>
                                <div className="delete-paymentinfo">
                                    <a onClick={showRemoveCredentials} className="cc-delete">{t("Delete")} <i className="fa fa-trash" aria-hidden="true"></i></a>
                                </div>
                            </div>                            
                        </div>}

                        <div className="row post-address-container">
                            <AddressBlock addressTitle="postalAddress"
                                address={addressPost} setAddress={setAddressPost}
                                errors={errors} setErrors={setErrors} />
                        </div>

                        <div className="row billing-address-container">
                            <AddressBlock addressTitle="billingAddress"
                                address={addressBill} setAddress={setAddressBill}
                                errors={errors} setErrors={setErrors} />
                        </div>

                        {!isRegistration && <div className="row profileBtns-container">
                            <div className="column-8 offset-2">
                                <Link className="back" to="/"><i className="fa fa-times-circle" aria-hidden="true"></i> {t("back")}</Link>
                                <a className="forward" onClick={updateProfile}>{t("profileSave")} <i className="fa fa-floppy-o" aria-hidden="true"></i></a>
                            </div>
                        </div>}

                        {isRegistration &&
                            <div className="row profilePassword-container">
                                <div className="column-8 offset-2">
                                    <h4>{t("password")}</h4>
                                </div>
                                <div className="column-8 offset-2">
                                    <Form.Group>
                                        <Form.Label>{t("userNameEditable")}</Form.Label>
                                        <Form.Control
                                            type='text'
                                            onChange={e => setField('Username', e.target.value)}
                                            isInvalid={!!errors.Username}
                                        />
                                        <Form.Control.Feedback type='invalid'>
                                            {errors.Username}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>{t("newPassword1")}</Form.Label>
                                        <Form.Control
                                            type='password'
                                            onChange={e => setField('NewPassword', e.target.value)}
                                            isInvalid={!!errors.NewPassword}
                                        />
                                        <Form.Control.Feedback type='invalid'>
                                            {errors.NewPassword}
                                        </Form.Control.Feedback>
                                        <p className="password-tip small">{t("passwordComplexityDesc")}</p>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{t("newPassword2")}</Form.Label>
                                        <Form.Control
                                            type='password'
                                            onChange={e => setField('ConfirmPassword', e.target.value)}
                                            isInvalid={!!errors.ConfirmPassword}
                                        />
                                        <Form.Control.Feedback type='invalid'>
                                            {errors.ConfirmPassword}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                            </div>
                        }

                        <div className="row profileTerms-container">
                            <div className="column-8 offset-2">
                                {isRegistration && <div>
                                    <input type="checkbox"
                                        onClick={handleAGBClick}
                                        checked={isAgbChecked} />{t("acceptAgb")}&nbsp;
                                    <a target="_blank" href="https://wyby.ch/de-ch/AGB">{t("agb")}</a>
                                </div>}
                            </div>
                        </div>

                        {isRegistration && <div className="row profileBtns-container">
                            <div className="column-8 offset-2">
                                <Link className="back" to="/"><i className="fa fa-times-circle" aria-hidden="true"></i> {t("back")}</Link>
                                <a className={"forward" + (isAgbChecked ? "" : " disabled")}
                                    onClick={createNewLessee}>
                                    {t("profileSave")} <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                </a>
                            </div>
                        </div>}

                        {!isRegistration && <>

                            <div className="row passwordTrigger-container">
                                <div className="column-8 offset-2">
                                    <a className="passwordTrigger-btn" onClick={toggleShowChangePassword}>{t("changePassword")} <i className="fa fa fa-pencil" aria-hidden="true"></i></a>
                                </div>
                            </div>

                            <Collapse in={showChangePassword}>
                                <div className='profile-password-wrapper'>
                                    <div className="row profilePassword-container">
                                        <div className="column-8 offset-2">
                                            <h4>{t("password")}</h4>
                                        </div>
                                        <div className="column-8 offset-2">
                                            <div className="form-group">
                                                <div className="form-label">
                                                    {t("userNameReadOnly")}
                                                </div>
                                                <div className="form-control">
                                                    <span className="usrName">{auth.user.AccountUsername}</span>
                                                </div>
                                            </div>

                                            <Form.Group>
                                                <Form.Label>{t("oldPassword")}</Form.Label>
                                                <Form.Control
                                                    type='password'
                                                    ref={refPwd}
                                                    onChange={e => setField('Password', e.target.value)}
                                                    isInvalid={!!errors.Password}
                                                />
                                                <Form.Control.Feedback type='invalid'>
                                                    {errors.Password}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Form.Group>
                                                <Form.Label>{t("newPassword1")}</Form.Label>
                                                <Form.Control
                                                    type='password'
                                                    ref={refNewPwd}
                                                    onChange={e => setField('NewPassword', e.target.value)}
                                                    isInvalid={!!errors.NewPassword}
                                                />
                                                <Form.Control.Feedback type='invalid'>
                                                    {errors.NewPassword}
                                                </Form.Control.Feedback>
                                                <p className="password-tip small">{t("passwordComplexityDesc")}</p>
                                            </Form.Group>

                                            <Form.Group>
                                                <Form.Label>{t("newPassword2")}</Form.Label>
                                                <Form.Control
                                                    type='password'
                                                    ref={refCnfPwd}
                                                    onChange={e => setField('ConfirmPassword', e.target.value)}
                                                    isInvalid={!!errors.ConfirmPassword}
                                                />
                                                <Form.Control.Feedback type='invalid'>
                                                    {errors.ConfirmPassword}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div className="row profileBtns-container">
                                        <div className="column-8 offset-2">
                                            <span>&nbsp;</span>
                                            <a className="forward" onClick={savePassword}>{t("savePassword")} <i className="fa fa-floppy-o" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </>}

                    </div>

                </div>
            </section>}

            {isRegistration && regnSuccess && <section className="profile-container">
                <div className="wrapper">
                    <div className="row profile-content">
                        <div className="column-12">
                            <h3 className="mali-blue">{t("regnSuccessTitle")}</h3>
                            <h4 className="mali-blue">{t("regnSuccessSubtitle")}</h4>
                        </div>
                    </div>
                    <div className="row registersSuccess-content">
                        <div className="column-6 offset-3">
                            <div className="registersSuccess-container">
                                <p>{t("regnSuccessText")}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row registersSuccessBtns-container">
                        <div className="column-6 offset-3">
                            <Link className="forward" to="/">
                                {t("regnSuccessGoHome")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>}
        </>
    );
}



export default UserProfile;